module.exports = __webpack_public_path__ + "static/media/carter-jonas.4eb23df9.png";